import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom'

// Grommet
import GridLoader from "react-spinners/GridLoader";

// Appt Components
import Anchor from '../../components/simple/anchor/Anchor'
import Box from '../../components/simple/box/Box'
import ResponsiveGrid from '../../components/compound/responsiveGrid/ResponsiveGrid'
import Select from '../../components/simple/input/Select';

import Text from '../../components/simple/text/Text'
import LocalStorageService from '../../services/LocalStorageService.js';
import AIService from '../../services/AIService';
import UserService from '../../services/UserService';
import { replaceTerms } from '../../utils/text';


// Shared Components
import BreadcrumbBar from '../shared/BreadcrumbBar'
import AILinkBar from './shared/AiLinkBar.js';
import ActionBoxSmall from '../../components/compound/actionBox/ActionBoxSmall.js';

function AIStudent (props) {
  const navigate = useNavigate()
  const activeOrg = LocalStorageService.get('activeOrg');
  const apiToken = LocalStorageService.get('apiToken');
  const terms = LocalStorageService.get('terms');

  const params = useParams();

  const userId = params.userid;
  const formId = params.formId;

  const [aiResponse, setAiResponse] = useState('');
  const [aiError, setAiError] = useState(false);
  const [aiThinking, setAiThinking] = useState(false);


  const [sections, setSections] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [selectedPromptId, setSelectedPromptId] = useState(null);

  const [studentValues, setStudentValues] = useState([]);
  const [activeStudent, setActiveStudent] = useState(null);

  

  const getUsers = async (type = 'user') => {
      const params = {
        fields: 'id,firstName,lastName,reference,type',
        limit: 2000,
        orgId: activeOrg.id,
        showFormerStudents: 'false',
        type,
      };
  
    //   setLoading(true);
      const users = await UserService.getUsers(apiToken, params);
      if (!users || users?.error) {
        // NotificationService.error(users.error)
      } else {
        // if (!unmounted) {
        if (users?.error) {
            setStudentValues(null);
        } else if (users?.data) {
            var studentUsers = [];
            for (const thisUser of users.data) {
              if (thisUser.firstName && thisUser.lastName) {
                studentUsers.push({
                  id: thisUser.id,
                  learnerNumber: thisUser.reference,
                  name: thisUser.firstName + ' ' + thisUser.lastName,
                });
              }
            }
            studentUsers = studentUsers.sort((a, b) =>
              a.name.localeCompare(b.name),
            );
            setStudentValues(studentUsers);
        }
        // }
      }
    };

  // useEffect(() => {
    
  //   let serviceUserTerm = lowercase(terms?.serviceUser || 'Service User')

  //   let newLabels = studentIncidentLabels
  //   // TEMPORARY
  //   // newLabels['custom'] = '[DEVELOPMENT ONLY] Ask your own question'

  //   setAvailableActions(newLabels)
    
  // }, [props.terms]);

  useEffect(() => {
    getPrompts()
  }, []);


  const getPrompts = async () => {
    let response = await AIService.getPrompts(apiToken, 'Student');
    if (response) {
      setPrompts(response);
      let newSections = [];
      for (const prompt of response) {
        if (!newSections.includes(prompt.subSection)) {
          newSections.push(prompt.subSection);
        }
      }

      newSections = newSections.sort((a, b) => a?.localeCompare(b));

      setSections(newSections);
    } else {
      console.error('Error getting prompts:', response?.error || 'Unknown error');    
    }
  };

  const requestInsight = async (promptId) => {

    if (!activeStudent?.id) {
        setAiResponse('')
        setAiError(true)
        return;
    }

    setSelectedPromptId(promptId);
    setAiResponse('Thinking...')



   
    setAiThinking(true)

    const response = await AIService.askAboutStudent(apiToken, activeStudent.id, promptId)

    setAiThinking(false)

    if (response?.response) {
      setAiResponse(response.response)
      setAiError(false)
    } else {
      setAiResponse('')
      setAiError(true)
    }
  }

  useEffect(() => {

    getUsers('student');
    // if (formId) {
        // requestInsight('summarise')
    // }
  }, [formId])



  return (
    <>
      <BreadcrumbBar
        title="AI Insights - Student"
        path={
          <>
            <Anchor href="/">BehaviourSmart</Anchor>
            <Text color="besmartBlue" size="xsmall">
              {window.location.pathname}
            </Text>
          </>
        }
      />

            
      <AILinkBar />

      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
            Disclaimer
          </Text>
          <Text color='secondary'>
            Our AI suggestions are for informational purposes only. Users should evaluate and apply these ideas based on their expertise. Behaviour Smart is not liable for outcomes from these suggestions. Always consult a qualified professional for personalised guidance. Please do not share data with parents or other parties that you're not authorised to.
            Please report inaccurate information or issues to <Anchor color='secondary' href="https://hello.behavioursmart.co.uk/ai-feedback" target="_blank">https://hello.behavioursmart.co.uk/ai-feedback</Anchor>
          </Text>
        </Box>
      </Box>


      <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text margin={{ top: 'xsmall', bottom: 'xsmall' }} size="xlarge">
            Select {(terms?.serviceUser || 'service user')} 
          </Text>
           <Select
                onChange={({ option }) => setActiveStudent(option)}
                labelKey="name"
                placeholder={
                    'Select ' +
                    (terms?.serviceUser || 'service user')
                }
                options={studentValues}
                onSearch={text => {
                    // The line below escapes regular expression special characters:
                    // [ \ ^ $ . | ? * + ( )
                    const escapedText = text.replace(
                    /[-\\^$*+?.()|[\]{}]/g,
                    '\\$&',
                    );
                    // Create the regular expression with modified value which
                    // handles escaping special characters. Without escaping special
                    // characters, errors will appear in the console
                    const exp = new RegExp(escapedText, 'i');

                    setStudentValues(
                      studentValues.filter(o => exp.test(o.name))
                    );
                }}
                valueKey={{ key: 'id', reduce: false }}
            />
        </Box>
      </Box>

      {(aiResponse || aiError) && <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'medium' }}
        >
          <Text margin={{ top: 'xsmall' }} size="xlarge">
            {aiResponse && <>
              <GridLoader color='#ff8300' loading={aiThinking} cssOverride={{ marginRight: '20px'}} />

                {!aiThinking && <Text style={{ whiteSpace: 'pre-line' }}>{aiResponse}</Text>}
            </>}
            {aiError && <Text color='red'>There was an error processing your request. Please try again.</Text>}
          </Text>
        </Box>
      </Box>}

      {!activeStudent && <Box
        background="white"
        direction="column"
        gap="small"
        margin={{ bottom: 'small' }}
        round="small"
      >
        <Box
          justify="between"
          pad={{ horizontal: 'medium', vertical: 'small' }}
        >
          <Text color='besmartBlue'>
            Select a {(terms?.serviceUser || 'service user')?.toLowerCase()} to continue
          </Text>
        </Box>
      </Box>}

         {activeStudent && <>
            { sections.map((key) => (
              <>
                <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
                  <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
                       <Text size="xlarge" weight="bold" color='secondary'>
                        {key}
                      </Text>
                  </Box>
                </Box>

                <ResponsiveGrid
                  rows={['auto']}
                  columns={{
                    small: ['auto'],
                    medium: ['33%', '33%', '33%'],
                    large: ['33%', '33%', '33%'],
                    xlarge: ['33%', '33%', '33%'],
                  }}
                  gap="small"
                >
                  { prompts?.filter(p => p.subSection === key).map((prompt) => (
                    <ActionBoxSmall
                      key={prompt.id}
                      width='100%'
                      title={replaceTerms(prompt.label, terms)}
                      onClick={() => requestInsight(prompt.id)}
                      active={parseInt(prompt.id) === parseInt(selectedPromptId)}
                    />    
                  ))}

                </ResponsiveGrid>

              </>
            ))}
          
         
         </>}

      {activeStudent && <Box margin={{ bottom: 'xlarge' }}>

        <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ top: 'medium', bottom: 'medium' }}>
          <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
             <Text size="xlarge" weight="bold" color='secondary'>
              Improve AI Insights
            </Text>
          </Box>
        </Box>


      <ResponsiveGrid
        rows={['auto']}
        columns={{
          small: ['auto'],
          medium: ['33%', '33%', '33%'],
          large: ['33%', '33%', '33%'],
          xlarge: ['33%', '33%', '33%'],
        }}
        gap="small"
      > 
        <ActionBoxSmall
          width='100%'
          title={'Report inaccurate information'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-feedback', '_blank')}
        />

        <ActionBoxSmall
          width='100%'
          title={'Make a suggestion'}
          onClick={() => window.open('https://hello.behavioursmart.co.uk/ai-prompts', '_blank')}
        />

      </ResponsiveGrid>

      </Box>}

    </>
  );
}

export default AIStudent
